import { GlobalResponseObject } from '../../../common';
import { CompanyModel } from './company.model';

export class CompanyResponse extends GlobalResponseObject {
    data?: CompanyModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: CompanyModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}